import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m33.167 10.591 4.242 4.242-10.651 10.651-1.402 1.402-.87-.87-2.121-2.121-.381-.381-.87-.87 1.402-1.402zm-1.305-5.259a.7.7 0 0 0-.495.205 2.27 2.27 0 0 0-.269 2.88L20.395 19.121a4.29 4.29 0 0 0-5.885.172.7.7 0 0 0 0 .99l5.353 5.353L9.739 35.758l-4.407 6.909 6.909-4.407 10.123-10.123 5.353 5.353a.697.697 0 0 0 .99 0 4.293 4.293 0 0 0 .172-5.885l10.704-10.704a2.266 2.266 0 0 0 2.88-.268.7.7 0 0 0 0-.99L32.357 5.537a.7.7 0 0 0-.495-.205" }) }) })
});
export default SvgPinOff;
